import { render } from "./AddCartWithImage.vue?vue&type=template&id=48adeb97&scoped=true"
import script from "./AddCartWithImage.vue?vue&type=script&lang=js"
export * from "./AddCartWithImage.vue?vue&type=script&lang=js"

import "./AddCartWithImage.vue?vue&type=style&index=0&id=48adeb97&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48adeb97"]])

export default __exports__